import MobileCarousel from './MobileCarousel';

export default MobileCarousel;
